import React, { useState } from 'react';
import './Input.css';

const Input = ({ 
  type, 
  placeholder, 
  value, 
  onChange, 
  icon, 
  iconAlt,
  error,
  required = false,
  size,
  disabled = false
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleIconClick = () => {
    if (type === 'password') {
      setShowPassword(!showPassword);
    }
  };

  return (
    <div className="input-container">
      <div className='input-wrapper'>
        <input
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`style-input ${error ? 'input-error' : ''} ${size ? size : ''}`}
          required={required}
          disabled={disabled}
          noValidate
        />
        {icon && (
          <img 
            src={type === 'password' ? (showPassword ? iconAlt : icon) : icon}
            alt="input icon" 
            className={`input-icon`}
            onClick={handleIconClick}
          />
        )}
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Input;
